export const AUTH_TOKEN_KEY = 'authToken';
export const USER_ID_KEY = 'userId';
export const PASSWORD_EXPIRATION_FLOW_KEY = 'passwordExpirationFlow';
